export const SERVICES_TYPES = {
  ApiService: Symbol('ApiService'),
  ChartStateStorageService: Symbol('ChartStateStorageService'),
  ChartWidgetService: Symbol('ChartWidgetService'),
  ConfigProviderService: Symbol('ConfigProviderService'),
  CookieService: Symbol('CookieService'),
  DataFeedService: Symbol('DataFeedService'),
  DeviceService: Symbol('DeviceService'),
  EnvService: Symbol('EnvService'),
  I18nService: Symbol('I18nService'),
  IntervalBarUpdateService: Symbol('IntervalBarUpdateService'),
  RealtimeBarUpdateService: Symbol('RealtimeBarUpdateService'),
  LogService: Symbol('LogService'),
  MessageListenerService: Symbol('MessageListenerService'),
  NotificationService: Symbol('NotificationService'),
  SentryService: Symbol('SentryService'),
  ServerTimeService: Symbol('ServerTimeService'),
  StorageService: Symbol('StorageService'),
  TemplateStorageService: Symbol('TemplateStorageService'),
  ThemeService: Symbol('ThemeService'),
  UrlParamsService: Symbol('UrlParamsService'),
  VirtualConsoleService: Symbol('VirtualConsoleService'),
  VisibilityService: Symbol('VisibilityService'),
};
